import { ContentViewer, HubItemLayoutContentViewerModel } from "client/Features/Hub/Builder/Viewer/ContentViewer";
import { HubDetailsLayout, MediaContentModel } from "client/Features/Hub/HubDetailsLayout";
import { EMPTY_ARRAY } from "client/Misc/utils";
import { ReactElement, useMemo } from "react";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { KnowledgeItemFormModel } from "./EditKnowledgeItemDialog";
import { ExistingHubItemImages } from "client/Api/Hub/common.composer";
import { HubLinkedDocumentViewModel } from "client/Api/Hub/common";
import { HubItemComposerDialog } from "../../HubItemComposerDialog/HubItemComposerDialog";
import { LinkedDocumentsViewer } from "client/Features/Hub/LinkedDocumentsViewer";
import { convertLayoutForDetails, convertMediaForDetails } from "client/Features/Hub/converters";

const {
	Step,
	Content,
	BuilderContainer
} = HubItemComposerDialog;

export type ArchivedContentStepProps = {
	isActive: boolean;
	model: KnowledgeItemFormModel;
	onChangeIsLoading(isLoading: boolean): void;
	originalImages: ExistingHubItemImages;
	infoAlerts?: ReactElement;
};

export const ArchivedContentStep = (props: ArchivedContentStepProps): ReactElement => {
	const {
		isActive,
		model,
		onChangeIsLoading,
		originalImages,
		infoAlerts
	} = props;

	const title: string = model.title ?? "";
	const linkedDocuments: readonly HubLinkedDocumentViewModel[] = model.linkedDocuments ?? EMPTY_ARRAY;

	const media = useMemo(
		(): MediaContentModel => {
			return convertMediaForDetails(
				model.media,
				HubItemKind.KnowledgeItem,
				originalImages.coverImage
			);
		},
		[model.media, originalImages.coverImage]
	);

	const layout = useMemo(
		(): HubItemLayoutContentViewerModel => {
			return convertLayoutForDetails(model.layout, originalImages.layoutImages);
		},
		[model.layout, originalImages.layoutImages]
	);

	const linkedDocumentsCount: number = linkedDocuments.length;

	return (
		<Step
			isActive={isActive}
			trackingId="archived-content-step"
		>
			<Content hasNoPadding>
				<BuilderContainer>
					{infoAlerts}
					<HubDetailsLayout>
						<HubDetailsLayout.SimpleTitle
							text={title}
						/>
						<HubDetailsLayout.Media
							media={media}
							hubItemKind={HubItemKind.KnowledgeItem}
						/>
						<HubDetailsLayout.Content>
							<ContentViewer
								hubItemKind={HubItemKind.KnowledgeItem}
								layout={layout}
							/>
						</HubDetailsLayout.Content>
						{(linkedDocumentsCount > 0) && (
							<HubDetailsLayout.LinkedDocuments count={linkedDocumentsCount}>
								<LinkedDocumentsViewer
									items={linkedDocuments}
									onChangeIsLoading={onChangeIsLoading}
								/>
							</HubDetailsLayout.LinkedDocuments>
						)}
					</HubDetailsLayout>
				</BuilderContainer>
			</Content>
		</Step>
	);
};
ArchivedContentStep.displayName = "ArchivedContentStep";
